import { MyApp } from "./app.component";
import { ENV } from '@app/env'
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { MatButtonModule, MatCardModule, MatTabsModule, MatChipsModule, MatIconModule, MatToolbarModule, MatDatepickerModule, MatFormFieldModule, MatNativeDateModule, MatMenuModule } from "@angular/material";

import { IonicStorageModule } from "@ionic/storage";
import { SignaturePadModule } from "angular2-signaturepad";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AuthProvider } from "../providers/auth/auth";
import { ImageProvider } from '../providers/image/image';
import { DatabaseProvider } from '../providers/database/database';
import { PdfProvider } from '../providers/pdf/pdf';
import { UtilityProvider } from '../providers/utility/utility';
import { DirectivesModule } from "../directives/directives.module";

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireFunctions } from 'angularfire2/functions';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { HomePageModule } from "../pages/home/home.module";
import { PatientsPageModule } from "../pages/patients/patients.module";
import { PatientDetailsPageModule } from "../pages/patient-details/patient-details.module";
import { PatientUploadPageModule } from "../pages/patient-upload/patient-upload.module";
import { ReportsPageModule } from "../pages/reports/reports.module";

import { AdminUsersPageModule } from "../pages/admin-users/admin-users.module";
import { AdminUsersAddPageModule } from "../pages/admin-users-add/admin-users-add.module";
import { AdminUtilityPageModule } from "../pages/admin-utility/admin-utility.module";

import { LoginPageModule } from "../pages/login/login.module";
import { SettingsPageModule } from "../pages/settings/settings.module";
import { OrderProvider } from '../providers/order/order';
import { ProgramPatientsPageModule } from "../pages/program-patients/program-patients.module";
import { ProgramHcpPageModule } from "../pages/program-hcp/program-hcp.module";
import { ProgramKpiPageModule } from "../pages/program-kpi/program-kpi.module";
import { ProgramFinanceMetricsPageModule } from "../pages/program-finance-metrics/program-finance-metrics.module";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ProgramClinicsPageModule } from "../pages/program-clinics/program-clinics.module";
import { ProgramClinicsAddPageModule } from "../pages/program-clinics-add/program-clinics-add.module";
import { ProgramDoctorsPageModule } from "../pages/program-doctors/program-doctors.module";
import { ProgramDoctorsAddPageModule } from "../pages/program-doctors-add/program-doctors-add.module";
import { FileUploadModule } from "ng2-file-upload";
import { ProgramDocsFilesPageModule } from "../pages/program-docs-files/program-docs-files.module";
import { ProgramInsurersPageModule } from "../pages/program-insurers/program-insurers.module";
import { ProgramInsurersAddPageModule } from "../pages/program-insurers-add/program-insurers-add.module";
import { ProgramPhoneCallsPageModule } from "../pages/program-phone-calls/program-phone-calls.module";
import { ProgramAdverseEventsPageModule } from "../pages/program-adverse-events/program-adverse-events.module";
import { ProgramPharmaciesPageModule } from "../pages/program-pharmacies/program-pharmacies.module";
import { ProgramPatientStatusPageModule } from "../pages/program-patient-status/program-patient-status.module";
import { ProgramBillingPageModule } from "../pages/program-billing/program-billing.module";
import { ProgramDispensingHistoryPageModule } from "../pages/program-dispensing-history/program-dispensing-history.module";
import { ProgramDispensingHistoryUploadPageModule } from "../pages/program-dispensing-history-upload/program-dispensing-history-upload.module";
import { ProgramPharmaciesAddPageModule } from "../pages/program-pharmacies-add/program-pharmacies-add.module";
import { PharmacyProvider } from '../providers/pharmacy/pharmacy';
import { InsurersProvider } from '../providers/insurers/insurers';
import { ClinicProvider } from '../providers/clinic/clinic';
import { AdminProvider } from '../providers/admin/admin';
import { DoctorProvider } from '../providers/doctor/doctor';
import { PatientProvider } from '../providers/patient/patient';
import { PatientAddEditPageModule } from "../pages/patient-add-edit/patient-add-edit.module";
import { TaskProvider } from '../providers/task/task';
import { AdherenceCallDialogComponent } from "../components/adherence-call-dialog/adherence-call-dialog";
import { ChartDialogComponent } from "../components/chart-dialog/chart-dialog";
import { StatusDialogComponent } from "../components/status-dialog/status-dialog";
import { AdverseEventsProvider } from '../providers/adverse-events/adverse-events';
import { DocumentProcessDialogComponent } from "../components/document-process-dialog/document-process-dialog";
import { ProgramSendFaxPageModule } from "../pages/program-send-fax/program-send-fax.module";
import { ReportPatientDetailsPageModule } from "../pages/report-patient-details/report-patient-details.module";
import { StiProvider } from '../providers/sti/sti';
import { ProgramFaxesPageModule } from "../pages/program-faxes/program-faxes.module";
import { PdfAdverseEventProvider } from "../providers/pdf/pdfAdverseEvent";
import { ReportDispensingPageModule } from "../pages/report-dispensing/report-dispensing.module";
import { ReportEnrolmentsPageModule } from "../pages/report-enrolments/report-enrolments.module";
import { ReportAdverseEventsPageModule } from "../pages/report-adverse-events/report-adverse-events.module";
import { ProgramDocsSecurePageModule } from "../pages/program-docs-secure/program-docs-secure.module";
import { PdfProviderFR } from "../providers/pdf/pdfFR";
import { ProgramShipmentsPageModule } from "../pages/program-shipments/program-shipments.module";
import { ProgramSecureUploadPageModule } from "../pages/program-secure-upload/program-secure-upload.module";
import { ShippingProvider } from '../providers/shipping/shipping';
import { StatusTherapyDialogComponent } from "../components/status-therapy-dialog/status-therapy-dialog";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MyApp
    ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    NgxDatatableModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatChipsModule,
    MatIconModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatMenuModule,
    SignaturePadModule,
    FileUploadModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp, {
      iconMode: "md",
      mode: "md",
      tabsPlacement: "bottom",
      scrollAssist: false, 
      autoFocusAssist: false
    }),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(ENV.FIREBASE_CONFIG),
    AngularFirestoreModule,
    AngularFireStorageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LoginPageModule,
    SettingsPageModule,
    HomePageModule,
    PatientsPageModule,
    PatientDetailsPageModule,
    PatientAddEditPageModule,
    PatientUploadPageModule,
    DirectivesModule,
    ReportsPageModule,

    AdminUsersPageModule,
    AdminUsersAddPageModule,
    AdminUtilityPageModule,

    ProgramPatientsPageModule,
    ProgramHcpPageModule,
    ProgramKpiPageModule,
    ProgramFinanceMetricsPageModule,
    ProgramClinicsPageModule,
    ProgramClinicsAddPageModule,
    ProgramDoctorsPageModule,
    ProgramDoctorsAddPageModule,
    ProgramDocsFilesPageModule,
    ProgramDocsSecurePageModule,
    ProgramInsurersPageModule,
    ProgramInsurersAddPageModule,
    ProgramPhoneCallsPageModule,
    ProgramAdverseEventsPageModule,
    ProgramPharmaciesPageModule,
    ProgramPharmaciesAddPageModule,
    ProgramPatientStatusPageModule,
    ProgramFaxesPageModule,
    ProgramBillingPageModule,
    ProgramDispensingHistoryPageModule,
    ProgramDispensingHistoryUploadPageModule,
    ProgramSendFaxPageModule,
    ProgramShipmentsPageModule,
    ProgramSecureUploadPageModule,

    ReportPatientDetailsPageModule,
    ReportDispensingPageModule,
    ReportEnrolmentsPageModule,
    ReportAdverseEventsPageModule

  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp, AdherenceCallDialogComponent,  ChartDialogComponent, StatusDialogComponent, StatusTherapyDialogComponent, DocumentProcessDialogComponent],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthProvider,
    ImageProvider,
    AngularFireAuth,
    AngularFireFunctions,
    PdfProvider,
    PdfProviderFR,
    PdfAdverseEventProvider,
    DatabaseProvider,
    UtilityProvider,
    PdfProvider,
    OrderProvider,
    PharmacyProvider,
    InsurersProvider,
    ClinicProvider,
    AdminProvider,
    DoctorProvider,
    PatientProvider,
    TaskProvider,
    AdherenceCallDialogComponent,
    ChartDialogComponent,
    StatusDialogComponent,
    StatusTherapyDialogComponent,
    AdverseEventsProvider,
    StiProvider,
    ShippingProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts